var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 2.25H19.5C20.2293 2.25 20.9288 2.53973 21.4445 3.05546C21.9603 3.57118 22.25 4.27065 22.25 5V19C22.25 19.7293 21.9603 20.4288 21.4445 20.9445C20.9288 21.4603 20.2293 21.75 19.5 21.75H14.75V20.25H19.5C19.8315 20.25 20.1495 20.1183 20.3839 19.8839C20.6183 19.6495 20.75 19.3315 20.75 19V5C20.75 4.66848 20.6183 4.35054 20.3839 4.11612C20.1495 3.8817 19.8315 3.75 19.5 3.75H14.75V2.25Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 3.75C4.80964 3.75 4.25 4.30964 4.25 5V19C4.25 19.6904 4.80964 20.25 5.5 20.25H8.75V3.75H5.5ZM19.5 20.25H10.25V3.75H19.5C20.1904 3.75 20.75 4.30964 20.75 5V11.3107H14.5607L17.8107 8.06066L16.75 7L12.2197 11.5303C11.9268 11.8232 11.9268 12.2981 12.2197 12.591L16.75 17.1213L17.8107 16.0607L14.5607 12.8107H20.75V19C20.75 19.6904 20.1904 20.25 19.5 20.25ZM2.75 5C2.75 3.48122 3.98122 2.25 5.5 2.25H19.5C21.0188 2.25 22.25 3.48122 22.25 5V19C22.25 20.5188 21.0188 21.75 19.5 21.75H5.5C3.98122 21.75 2.75 20.5188 2.75 19V5Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.e16c6356639fcbb3a7a7f60f64005b89.svg";
export { ForwardRef as ReactComponent };